﻿$.fn.dxCtrlPagePlanitiReunionExterneFinal = function custom_dxCtrlPagePlanitiReunionExterneFinal(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexternefinal dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterneFinal(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterneFinal = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dataPlanitiReunion = null
    function mConstruit() {
        container.empty();
        container.css("text-align", "left")
        option.bddCtrl.mAjaxCall({ command: "getdataplanitireunion", id_planiti_reunion: option.idPlanitiReunion, id_planiti_reunion_orga: option.idPlanitiReunionOrga }, function (data) {
            dataPlanitiReunion = data
            mRempli()
            if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
        })

    }

    function mRempli() {
        if (typeof dataPlanitiReunion.planiti_reunion == 'undefined') {
            //la réunion n'existe plus
            var $DivValide = $("<div style='padding:30px 0;font-size:200%;'>Cette réunion n'existe plus</div>").appendTo(container)
        } else {
            var planitiReunion = dataPlanitiReunion.planiti_reunion[0]
            if (option.creation) {
                //on vient de créer la réunion
                var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
                $("<div style='font-weight:bold;font-size:140%;'>Votre réunion est programmée!</div>").appendTo($DivValide)
                $("<div style='font-size:100%;'>Un email de confirmation vous a été envoyé.</div>").appendTo($DivValide)
                if (typeof dataPlanitiReunion.lst_email != 'undefined' && dataPlanitiReunion.lst_email.length > 0) {
                    if (dataPlanitiReunion.lst_email.length == 1) {
                        $("<div style='font-size:100%;'>Un email d'annonce de la réunion a été envoyé à votre invité.</div>").appendTo($DivValide)
                    } else {
                        $("<div style='font-size:100%;'>Un email d'annonce de la réunion a été envoyé à vos " + dataPlanitiReunion.lst_email.length + " invités.</div>").appendTo($DivValide)
                    }
                }
            } else if (option.reprogrammation) {
                //on vient de reprogrammer la réunion
                var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
                $("<div style='font-weight:bold;font-size:140%;'>Votre réunion a été reprogrammée!</div>").appendTo($DivValide)
                $("<div style='font-size:100%;'>Un email de confirmation vous a été envoyé.</div>").appendTo($DivValide)
                if (typeof dataPlanitiReunion.lst_email != 'undefined' && dataPlanitiReunion.lst_email.length > 0) {
                    if (dataPlanitiReunion.lst_email.length == 1) {
                        $("<div style='font-size:100%;'>Un email d'annonce de la réunion a été envoyé à votre invité.</div>").appendTo($DivValide)
                    } else {
                        $("<div style='font-size:100%;'>Un email d'annonce de la réunion a été envoyé à vos " + dataPlanitiReunion.lst_email.length + " invités.</div>").appendTo($DivValide)
                    }
                }
            } else if (option.annulation) {
                //on vient d'annuler la réunion
                var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
                $("<div style='font-weight:bold;font-size:140%;'>Votre réunion a été annulée!</div>").appendTo($DivValide)
                $("<div style='font-size:100%;'>Un email d'annulation vous a été envoyé.</div>").appendTo($DivValide)
                if (typeof dataPlanitiReunion.lst_email != 'undefined' && dataPlanitiReunion.lst_email.length > 0) {
                    if (dataPlanitiReunion.lst_email.length == 1) {
                        $("<div style='font-size:100%;'>Un email d'annonce de l'annulation de la réunion a été envoyé à votre invité.</div>").appendTo($DivValide)
                    } else {
                        $("<div style='font-size:100%;'>Un email d'annonce de l'annulation de la réunion a été envoyé à vos " + dataPlanitiReunion.lst_email.length + " invités.</div>").appendTo($DivValide)
                    }
                }
                //} else if (planitiReunion.date_annulation != null) {
                //    //La réunion est annulé
                //    var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
                //    $("<div style='font-weight:bold;font-size:140%;color:red;'>Cette réunion a été annulée le " + DevExpress.localization.formatDate(planitiReunion.date_annulation, "eeee d MMMM yyyy") + " à " + DevExpress.localization.formatDate(planitiReunion.date_annulation, "HH:mm") + "</div>").appendTo($DivValide)
                //} else if (planitiReunion.date_debut < parametre.dateNow) {
                //    //La réunion est passé
                //    var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
                //    $("<div style='font-weight:bold;font-size:140%;color:orange;'>Cette réunion est termine</div>").appendTo($DivValide)
            }

            //if (planitiReunion.date_debut < parametre.dateNow) {
            //    //La réunion est passé
            //    container.css("text-decoration", "line-through")
            //    var $DivValide = $("<div style='padding:30px 0;'/>").appendTo(container)
            //    $("<div style='font-weight:bold;font-size:140%;color:orange;'>Cette réunion est termine</div>").appendTo($DivValide)
            //}


            //var $DivDate = $("<div/>").appendTo(container)
            //$DivDate.css("text-decoration", ((planitiReunion.date_debut < parametre.dateNow) ? "line-through" : ""))
            //$("<div style='font-weight:bold;font-size:120%;'>Le <b>" + DevExpress.localization.formatDate(planitiReunion.date_debut, "eeee d MMMM yyyy") + "</b> de <b><u>" + DevExpress.localization.formatDate(planitiReunion.date_debut, "HH:mm") + "</u></b> à <b><u>" + DevExpress.localization.formatDate(planitiReunion.date_fin, "HH:mm") + "</u></b></div>").appendTo($DivDate)

            //$("<div style='font-weight:bold;font-size:140%;margin:25px 0 5px 0;' class='dx-theme-accent-as-text-color'>Lieu</div>").appendTo(container)
            //switch (parseInt(planitiReunion.id_type_lieu)) {
            //    case 0://tel
            //        $("<div>Cette réunion se déroulera au téléphone</div>").appendTo(container)
            //        $("<div>Vous serez appeler à l'heure de la réunion sur le <b>" + planitiReunion.tel_sms_appel + "</b></div>").appendTo(container)
            //        break;
            //    case 1://zoom
            //        $("<div>Cette réunion se déroulera via une conférence vidéo Zoom</div>").appendTo($Div)
            //        $("<div>A l'heure de la réunion, vous pourrez vous connecter via le lien zoom suivant:</div>").appendTo(container)
            //        $("<a href='" + planitiReunion.url_invite_zoom + "'>" + planitiReunion.url_invite_zoom + "</a>").appendTo(container)
            //        break;
            //}

            //if (typeof planitiReunion.lst_email != 'undefined' && planitiReunion.lst_email.length > 0) {
            //    $("<div style='font-weight:bold;font-size:140%;margin:25px 0 5px 0;' class='dx-theme-accent-as-text-color'>Invité (" + planitiReunion.lst_email.length + ")</div>").appendTo($Div)
            //    planitiReunion.lst_email.forEach(function (email) {
            //        $("<div><u>" + email + "</u></div>").appendTo(container)
            //    })
            //}

            var $DivDetail = $("<div/>").appendTo(container)
            var isAnnule = true
            dataPlanitiReunion.planiti_reunion_orga.forEach(function (planitiReunionOrga, idx) {
                if (planitiReunionOrga.date_annulation == null) isAnnule = false
            })
            if (isAnnule) $DivDetail.css("text-decoration", "line-through")

            $("<div/>").appendTo($DivDetail).dxCtrlPlanitiReunionDetail({
                bddCtrl: option.bddCtrl,
                planitiReunion: planitiReunion
            })

            $("<div style='padding-top:25px;padding-left:30px;'/>").appendTo($DivDetail).dxCtrlPlanitiReunionOrgaDetail({
                bddCtrl: option.bddCtrl,
                dataPlanitiReunion: dataPlanitiReunion,
                showBt: (!option.creation && !option.reprogrammation && !option.annulation && !option.reprogrammation && planitiReunion.date_debut > parametre.dateNow),
                onDemandeAnnulation: option.onDemandeAnnulation,
                onDemandeReprogrammation: option.onDemandeReprogrammation
            })

            //if (!option.creation && !option.reprogrammation && !option.annulation && !option.reprogrammation && dataPlanitiReunion.planiti_reunion_orga[0].date_annulation == null && planitiReunion.date_debut > parametre.dateNow) {
            //    var $Table = $("<table style='width:100%;margin-top:35px;'/>").appendTo(container)
            //    var $Tr = $("<tr/>").appendTo($Table)
            //    if (option.dataPlaniti.planiti.nbre_organisateur == 1) {
            //        var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
            //        $("<div/>").appendTo($Td).dxCtrlButton({
            //            text: "Annuler la réunion",
            //            onClick: function (e) {
            //                option.onDemandeAnnulation()
            //            }
            //        })
            //        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            //        $("<div/>").appendTo($Td).dxCtrlButton({
            //            text: "Reprogrammer la réunion",
            //            onClick: function (e) {
            //                option.onDemandeReprogrammation()
            //            }
            //        })
            //    }
            //    var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            //} else {
            //}
            var $Div = $("<div style='margin-top:30px;'/>").appendTo(container)
            var $A = $("<a href='javascript:void(0)'>Programmer une nouvelle réunion</a>").appendTo($Div)
            $A.on("click", function () {
                window.open(parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + planitiReunion.id_planiti + "/0/0/0/0/planiti", "_self")
            })
        }

    }

    this.getDateDebut = function () {
        return dataPlanitiReunion.planiti_reunion[0].date_debut
    }

    this.getDateFin = function () {
        return dataPlanitiReunion.planiti_reunion[0].date_fin
    }

    this.element = function () { return container; }

    mConstruit();
}